import { useMemoizedFn } from 'ahooks';
import { assignWith } from 'lodash';
import { useConfigAtomValues } from '../state';
import { isLaxNull, formatPriceJson } from '../_utils/tool';
import i18n from '../_utils/i18n';
var defaultOptions = {
  code: 'USD',
  multiple: 1
};

// 合并选项的策略
var assignStrategies = function assignStrategies(objValue, srcValue) {
  return isLaxNull(srcValue) ? objValue : srcValue;
};
export default function useSettleAmountFormatter() {
  var _useConfigAtomValues = useConfigAtomValues(),
    settleAmountFormatter = _useConfigAtomValues.settleAmountFormatter;
  var formatter = useMemoizedFn(function (value) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // 合并后的选项
    var finalizeOptions = assignWith({
      lang: i18n.language
    }, defaultOptions, options, assignStrategies);
    if (typeof settleAmountFormatter === 'function') {
      return settleAmountFormatter(value, {
        code: finalizeOptions.code,
        lang: finalizeOptions.lang
      });
    }
    return formatPriceJson(value, finalizeOptions.code);
  });
  return formatter;
}